module.exports = __webpack_public_path__ + "prod/20251121165348/img/service.edbff227.png";